<template>
  <div class="about">

    <section v-if="content && content.about">
      <h1>{{ content.about.title }}</h1>
      <div class="grid-2-col">  
        <div class="about__body"> 
          <div v-for="(section, index) in content.about.sections" :key="index" class="about-section">
            <h2>{{ section.title }}</h2>
            <p>{{ section.description }}</p>
          </div>
        </div>
        <div class="about__img image">
          <img src="/img/modern-equipped-computer.webp" alt="it team">
        </div>
      </div>
    </section>


    <section v-if="content && content.whyChooseUs" ref="whyChooseUs">
      <h2 class="center">{{ content.whyChooseUs.title }}</h2>
      <div class="grid-3-col">
        <div class="column">
          <div v-for="(item, index) in content.whyChooseUs.list.slice(0, 3)" :key="index" class="about__item"
               :class="{ 'visible': itemVisible[index] }">
            <div class="about__top">
              <div class="about__icon">
                <i :class="item.icon"></i>
              </div>
              <div class="about__item-title">{{ item.title }}</div>
            </div>
            <p>{{ item.description }}</p>
          </div>
        </div>

        <div class="image">
          <img src="/img/ihone_14.webp" alt="iphone 14" class="large-image">
        </div>

        <div class="column">
          <div v-for="(item, index) in content.whyChooseUs.list.slice(3, 6)" :key="index + 3" class="about__item"
               :class="{ 'visible': itemVisible[index + 3] }">
            <div class="about__top">
              <div class="about__icon">
                <i :class="item.icon"></i>
              </div>
              <div class="about__item-title">{{ item.title }}</div>
            </div>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <section v-if="content && content.progressSection">
      <div class="grid-2-col">
        <div>
          <h2>{{ content.progressSection.title }}</h2>
          <p class="progress__description">{{ content.progressSection.description }}</p>
        </div>
        <div class="progress-block" ref="progressSection">
          <div v-for="(item, index) in content.progressSection.list" :key="index" class="progress-item">
            <div class="title">{{ item.title }}</div>
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: isProgressVisible ? item.value + '%' : '0%' }"></div>
            </div>
            <div class="percentage">{{ item.value }}%</div>
          </div>
        </div>
      </div>
    </section>

    <div v-if="!content">
      <p>Content is loading...</p>
    </div>
  </div>
</template>

<script>
import { useaboutStore } from '@/stores/aboutStore';

export default {
  name: 'aboutTemplate',
  data() {
    return {
      content: null,
      isProgressVisible: false,
      itemVisible: [] 
    };
  },
  watch: {
    '$i18n.locale': {
      handler(newLocale) {
        console.log('Локаль изменилась:', newLocale);
        this.loadContent(newLocale);
      },
      immediate: true 
    }
  },
  methods: {
    async loadContent(locale) {
      const aboutStore = useaboutStore();
      await aboutStore.loadContent(locale);
      this.content = aboutStore.content;
      this.itemVisible = new Array(this.content?.whyChooseUs?.list?.length).fill(false); 
      this.$nextTick(() => {
        if (this.$refs.whyChooseUs) this.observeWhyChooseUs();
        if (this.$refs.progressSection) this.observeProgressBlock();
      });
    },
    observeWhyChooseUs() {
      if (!this.$refs.whyChooseUs) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.animateWhyChooseUs();
            observer.disconnect();
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(this.$refs.whyChooseUs);
    },
    animateWhyChooseUs() {
      this.content.whyChooseUs.list.forEach((_, index) => {
        setTimeout(() => {
          this.itemVisible[index] = true;
        }, index * 200);
      });
    },
    observeProgressBlock() {
      if (!this.$refs.progressSection) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              this.isProgressVisible = true;
            }, 200);
            observer.disconnect();
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(this.$refs.progressSection);
    }
  }
};
</script>

